import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCUEjlORLEkvz4KwPccf2oFexyHek15a0Y",
  authDomain: "primium-flats-india.firebaseapp.com",
  projectId: "primium-flats-india",
  storageBucket: "primium-flats-india.firebasestorage.app",
  messagingSenderId: "87760708341",
  appId: "1:87760708341:web:da25d58caba4469b86dbbc",
  measurementId: "G-DTWYW6RXK7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);